module.exports = __webpack_public_path__ + "img/tu1.19146f4e.png";